<template>
  <div>
    <v-tooltip bottom>
      <template #activator="{ on, attrs }">
        <SecondaryButton
          @click="viewDetails"
          v-if="params.context.parentComponent.permissions.view"
          x-small
          v-on="on"
          v-bind="attrs"
          btnClass="mr-2 rounded"
          icon="mdi-eye"
          iconClass=""
        >
        </SecondaryButton>
      </template>
      <span>View Details</span>
    </v-tooltip>

    <v-tooltip bottom>
      <template #activator="{ on, attrs }">
        <WarningButton
          @click="viewLocation"
          v-if="params.context.parentComponent.permissions.view"
          x-small
          v-on="on"
          v-bind="attrs"
          btnClass="mr-2 rounded"
          icon="mdi-map-marker-radius"
          iconClass=""
        >
        </WarningButton>
      </template>
      <span>View Location</span>
    </v-tooltip>

    <v-tooltip bottom>
      <template #activator="{ on, attrs }">
        <PrimaryButton
          @click="editItem"
          v-if="params.context.parentComponent.permissions.change"
          x-small
          v-on="on"
          v-bind="attrs"
          btnClass="mr-2 rounded"
          icon="mdi-pencil"
          iconClass=""
        >
        </PrimaryButton>
      </template>
      <span>Edit</span>
    </v-tooltip>

    <v-tooltip bottom>
      <template #activator="{ on, attrs }">
        <WarningButton
          @click="showLogs"
          v-if="params.context.parentComponent.permissions.view"
          x-small
          v-on="on"
          v-bind="attrs"
          btnClass="mr-2 rounded"
          icon="mdi-text-box"
          iconClass=""
        >
        </WarningButton>
      </template>
      <span>Logs</span>
    </v-tooltip>
    <v-tooltip bottom>
      <template #activator="{ on, attrs }">
        <ErrorButton
          x-small
          @click="addTags"
          v-if="params.context.parentComponent.permissions.view"
          v-on="on"
          v-bind="attrs"
          btnClass="mr-2 rounded"
          icon="mdi-tag"
          iconClass=""
        >
        </ErrorButton>
      </template>
      <span>Add Tags</span>
    </v-tooltip>
  </div>
</template>

<script>
export default {
  methods: {
    viewDetails() {
      this.$router.push({
        name: "customer-address-details",
        params: {
          id: this.params.data.id,
        },
      });
    },
    viewLocation() {
      this.params.context.parentComponent.getCustomerAddressMap(
        this.params.data.id
      );
    },
    editItem() {
      this.params.context.parentComponent.editCustomerAddress(
        this.params.data.id
      );
    },
    showLogs() {
      this.params.context.parentComponent.getCustomerAddressLogs(
        this.params.data.id,
        this.params.data.customer
      );
    },
    addTags() {
      this.params.context.parentComponent.addTagsForCustomerAddress(
        this.params.data
      );
    },
  },
};
</script>

<style></style>
